// import React from 'react';
// // import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
// import './Footer.css'

// const Footer = ({ className }) => {
//   return (
//     <footer className={`footer position-sticky ${className}`}>
//       <div className="container">
//         <div className="row align-items-center justify-content-between ">
//           {/* Logo Container */}
//           <div className="col-auto">
//             <a href="https://www.workglow.in/" className="footerLink">
//               {/* <div className="footer-logo-containerhead">
//                 <p className="bglogo"></p>
//                 <p className="SAPlogo"></p>
//               </div> */}
//             </a>
//           </div>

//           {/* Electric Bolt Icon */}
//           {/* <div className="col-auto">
//             <ElectricBoltIcon style={{ fontSize: '1.2em', margin: '0 5px', color: 'black' }} />
//           </div> */}

//           {/* WG Text */}
//           <div className="col text-center">
//             <p className="mb-0 footer-text">
//               Powered by Workglow Solutions
//             </p>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;


import React from 'react';
import './Footer.css';
const Footer = () => {
  return (
    <footer className="footer text-center">
      <div className="container d-flex justify-content-center align-items-center h-100 p-0">
        <p className="mb-0" style={{ fontSize: '0.8rem' }}>
           {/* <strong>Powered by 🦉 Workglow Solutions </strong> */}
           <strong>Powered by Workglow Solutions </strong>
        </p>
      </div>
    </footer>
  );
};

export default Footer;

